import API from 'app/api';
import parseResponse from 'app/api/requests/parsers/response';
import logError from 'app/error/logError';
import { Watchlist } from 'app/api/entities/watchlist';

const fetchWatchlistItems = ({ accountId, contentIds }) =>
  API.Content.fetchWatchlistItems({ accountId, contentIds })
    .then(parseResponse)
    .then(Watchlist)
    .catch(logError);

const addToWatchlist = ({ accountId, seriesId }) =>
  API.Content.addToWatchlist({ accountId, content_id: seriesId }).catch(
    logError,
  );

const removeFromWatchlist = ({ accountId, seriesId }) =>
  API.Content.removeFromWatchlist({ accountId, seriesId }).catch(logError);

export { fetchWatchlistItems, addToWatchlist, removeFromWatchlist };
